import fieldAccessDestructor from "../../utils/accessUtils/fieldAccessFinder";

const HasThisFieldAccess = ({ children, fieldAccesses, fieldNames, type }) => {
  // const candSeeThisField = fieldAccessDestructor(fieldAccesses, fieldName)[0];
  const hasAccesses = [];
  for (const each of fieldNames) {
    const accessKeyOfObject = each.split("_")[0];
    const hasAccess = fieldAccessDestructor(fieldAccesses[accessKeyOfObject], each, "unset")[0];
    hasAccesses.push(hasAccess);
  }
  if (!type) {
    const finalDecision = hasAccesses.includes(false);
    if (!finalDecision) {
      return children;
    }
  } else if (type === "OR") {
    const finalDecision = hasAccesses.includes(true);
    if (finalDecision) {
      return children;
    }
  }
};

export default HasThisFieldAccess;
